/* eslint-disable camelcase */
import { createAction, handleActions } from 'redux-actions';
import { useService } from '@piwikpro/platform';
import { MetaSitePermissionsForUserGroup } from '../../../../interfaces';

const inUnderMetaSitePermissionRoute = new RegExp('/meta-sites/(.*)/permissions/user-groups(.*)');

export const metaSitePermissionsForUserGroupsFetchInitialized = createAction(
  '@platform/query/metaSitePermissionsForUserGroups/list/init',
);
export const metaSitePermissionsForUserGroupsFetchSucceeded = createAction(
  '@platform/query/metaSitePermissionsForUserGroups/list/success',
  (payload: any) => payload,
);
export const metaSitePermissionsForUserGroupsFetchFailed = createAction(
  '@platform/query/metaSitePermissionsForUserGroups/list/failed',
);
export const metaSitePermissionsForUserGroupUpdateSucceeded = createAction(
  '@platform/command/metaSitePermissionsForUserGroups/update/success',
  (payload: any) => payload,
);
export const metaSitePermissionsForUserGroupUpdateFailed = createAction(
  '@platform/command/metaSitePermissionsForUserGroups/update/failed',
);

interface MetaSitePermissionsState {
  isLoading: boolean
  failed: boolean
  permissions: MetaSitePermissionsForUserGroup[]
  total: number
}

const initialState: MetaSitePermissionsState = {
  isLoading: false,
  permissions: [],
  total: 0,
  failed: false,
};

// TODO: move to proper crate
export const fetchMetaSitePermissionsForUserGroups = (
  id: string,
  filters: { offset?: number, limit?: number, search: string } = { search: '' },
) => async (dispatch: Function) => {
  const httpClient = useService('HttpCrate.httpClient');
  const notifyOnFail = useService('NotificationCrate.interceptors.NotifyOnFail');
  const config = useService('config');

  dispatch(metaSitePermissionsForUserGroupsFetchInitialized());

  try {
    const queryParams = {
      offset: filters.offset,
      limit: filters.limit,
      search: filters.search || '',
    };
    const resp = await httpClient.request({
      endpoint: `${config.get('ACCESS_CONTROL_URL')}/meta-site/${id}/permission/user-group`,
      queryParams,
      method: 'GET',
    }).intercept(notifyOnFail).jsonApi().send();

    dispatch(metaSitePermissionsForUserGroupsFetchSucceeded(resp));
  } catch (err) {
    dispatch(metaSitePermissionsForUserGroupsFetchFailed());
  }
};

export const updateMetaSitePermissionsForUserGroup = (
  metaSiteId: string, userGroupId: string, attributes: any,
) => async (dispatch: Function) => {
  const httpClient = useService('HttpCrate.httpClient');
  const notifyAboutUpdate = useService('NotificationCrate.interceptors.NotifyAboutUpdate');
  const config = useService('config');

  try {
    await httpClient.request({
      endpoint: `${config.get('ACCESS_CONTROL_URL')}/meta-site/${metaSiteId}/permission/user-group/${userGroupId}`,
      method: 'POST',
      body: {
        data: {
          type: 'meta-site/permission/user-group',
          attributes,
        },
      },
    }).intercept(notifyAboutUpdate).jsonApi().send();

    dispatch(metaSitePermissionsForUserGroupUpdateSucceeded({ id: userGroupId, attributes }));
  } catch (err) {
    dispatch(metaSitePermissionsForUserGroupUpdateFailed());
    throw err;
  }
};

const reducer = handleActions<MetaSitePermissionsState, any>({
  [metaSitePermissionsForUserGroupsFetchInitialized.toString()]: state => ({
    ...state,
    failed: false,
    isLoading: true,
  }),
  [metaSitePermissionsForUserGroupsFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    permissions: payload.data,
    total: payload.meta.total,
  }),
  [metaSitePermissionsForUserGroupsFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  [metaSitePermissionsForUserGroupUpdateSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    permissions: state.permissions.map(
      permission => (permission.id === payload.id
        ? {
          ...permission,
          attributes:
            { ...permission.attributes, permission: payload.attributes.permission },
        }
        : permission),
    ),
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!inUnderMetaSitePermissionRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
